import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ConfirmationService, LazyLoadEvent, MessageService, PrimeNGConfig} from 'primeng/api';
import {Constant} from '../util/constant';
import {SharedService} from '../web-services/shared.service';
import {ConstantService} from '../web-services/constant.service';
import {Labels} from '../util/labels';
import {CompnayPatientsService} from '../web-services/compnay-patients.service';
import {UsersService} from '../web-services/users.service';

declare var closeAddOverlaydiv: Function;
declare var closeSearchOverlaydiv: Function;
declare var openAddOverlaydiv: Function;

@Component(
    {selector: 'app-compnay-patients', templateUrl: './compnay-patients.component.html', styleUrls: ['./compnay-patients.component.css']})
export class CompnayPatientsComponent implements OnInit {
    public labels = Labels;
    formButton: string = this.translate(this.labels.btnAdd);
    submitted = false;
    selectedIndex = -1;
    updateCompanyPatientId = null;
    usersList: any = [];
    compnayPatientsList: any = [];
    compnayPatientsSearch: FormGroup;
    clearSearchBtn = false;
    totalRecords;
    itemPerPage: number = Constant.ITEM_PER_PAGE;
    compnayPatientsForm: FormGroup;
    constantList = [];
    pageNo: number = 0;
    onValueChange = true;

    showSearchDialog = false;
    showSearchBtn = false;
    showAddDialog = false;
    showAddBtn = false;
    editTag = false;
    disableColumn = false;
    passwordType = 'password';

    addEditTitle = '';
    constructor(
        private compnayPatientsServices: CompnayPatientsService, private usersServices: UsersService, private primengConfig: PrimeNGConfig,
        private confirmation: ConfirmationService, private messageService: MessageService, private route: Router,
        private loader: NgxUiLoaderService, private constantService: ConstantService, private sharedService: SharedService
    ) {
    };

    get addUpdateTitle() {
        return this.updateCompanyPatientId == null ? this.translate(this.labels.btnAdd) : this.translate(this.labels.btnUpdate);
    }

    onClearSearch() {
        this.compnayPatientsSearch.reset();
        this.selectedIndex = -1;
    }

    onSearch() {
        this.clearSearchBtn = true;
        this.countCompnayPatients();
        this.findAllCompnayPatients();
        closeSearchOverlaydiv();
    }

    startLoader() {
        this.loader.start();
        setTimeout(() => {
            this.loader.stop();
        }, 3000);
    }

    stopLoader() {
        this.loader.stop();
    }

    countCompnayPatients() {
        this.compnayPatientsServices.countCompnayPatients(this.compnayPatientsSearch.value).subscribe(res => {
            if (res['message'] == 'Success') {
                this.totalRecords = res['data'][0];
                this.findAllCompnayPatients();
            } else {
                this.totalRecords = 0;
            }
        }, err => {
            console.error('err: ', err);
        });
    }

    onSubmit() {
        this.addUpdateCompnayPatients(this.compnayPatientsForm.value);
        this.submitted = false;
        this.onClearAdd();
    }

    onPageChnage(event: LazyLoadEvent) {
        this.itemPerPage = event.rows;
        this.pageNo = event.first / event.rows;
        this.findAllCompnayPatients();
    }

    clearSearchResult() {
        this.clearSearchBtn = false;
        this.compnayPatientsSearch.reset();
        this.countCompnayPatients();
        // this.findAllCompnayPatients();
    }

    addUpdateCompnayPatients(compnayPatients) {
        this.startLoader();
        if (this.updateCompanyPatientId == null) {
            this.compnayPatientsServices.addCompnayPatients(this.compnayPatientsForm.value).subscribe(res => {
                if (res['message'] == 'Success') {
                    compnayPatients = res['data'][0];
                    this.compnayPatientsList.push(compnayPatients);
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.btnAdd),
                                                detail: this.translate(this.labels.entityNameCompnayPatients)
                                            });
                    this.submitted = true;
                    this.showHideAddDialog();
                    this.countCompnayPatients();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
        } else {
            compnayPatients.companyPatientId = this.updateCompanyPatientId;
            this.compnayPatientsServices.updateCompnayPatients(compnayPatients).subscribe(res => {
                if (res['message'] == 'Success') {
                    this.compnayPatientsList[this.selectedIndex] = res['data'][0];
                    this.submitted = true;
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.btnUpdate),
                                                detail: this.translate(this.labels.entityNameCompnayPatients)
                                            });
                    this.showSearchBtn = false;
                    this.showAddBtn = false;
                    this.showSearchDialog = false;
                    this.showAddDialog = false;
                    this.editTag = false;
                    this.refresh();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
            this.updateCompanyPatientId = null;
            this.onClearAdd();
            this.formButton = this.translate(this.labels.btnAdd);
        }
        // this.stopLoader();
    }

    translate(label) {
        return this.sharedService.verifyLabel(label, this.constantList);
    }

    getConstantList(formId) {
        this.constantService.getFormConstantsList(formId).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.constantList = data['data'];
            } else {
                this.constantList = [];
            }
        });
    }

    ngOnInit() {
        this.findAllUsers();
        this.compnayPatientsForm = new FormGroup({
                                                     companyId: new FormControl(0, [Validators.required, Validators.min(0)]),
                                                     patientId: new FormControl(0, [Validators.required, Validators.min(0)]),
                                                     userId: new FormControl(),
                                                 });
        this.compnayPatientsSearch = new FormGroup(
            {companyId: new FormControl(), patientId: new FormControl(), userId: new FormControl(),});
        this.countCompnayPatients();
        this.findAllCompnayPatients();
        this.getConstantList(1234);
        this.primengConfig.ripple = true;
        this.clearSearchBtn = false;
        this.compnayPatientsSearch.valueChanges.subscribe(data => {
            this.onValueChange = false;
        });
    }

    findAllCompnayPatients() {
        this.startLoader();
        this.compnayPatientsServices.findAllCompnayPatients(this.compnayPatientsSearch.value, this.pageNo, this.itemPerPage).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    this.compnayPatientsList = res['data'];
                } else {
                    this.compnayPatientsList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    deleteByIdCompnayPatients(companyPatientId: number, index) {
        this.confirmation.confirm({
                                      message: this.translate(this.labels.DELETE_MSG), accept: () => {
                this.startLoader();
                this.compnayPatientsServices.deleteByIdCompnayPatients(companyPatientId).subscribe(res => {
                    if (res['message'] == 'Success') {
                        this.compnayPatientsList.splice(index, 1);
                        this.messageService.add({
                                                    severity: 'warn',
                                                    summary: this.translate(this.labels.btnDelete),
                                                    detail: this.translate(this.labels.entityNameCompnayPatients)
                                                });
                        this.countCompnayPatients();
                    } else {
                        console.error('error: ', res['documentation']);
                        this.startLoader();
                    }
                }, err => {
                    console.error('err: ', err);
                    this.stopLoader();
                });
            }
                                  });
    }

    loadCompnayPatientsToEdit(companyPatientId: number, index) {
        this.addEditTitle = this.labels.btnEdit;
        let compnayPatients = this.compnayPatientsList.find(x => x['companyPatientId'] == companyPatientId);
        this.submitted = null;
        this.formButton = this.translate(this.labels.btnEdit);
        this.updateCompanyPatientId = compnayPatients['companyPatientId'];
        this.selectedIndex = index;
        this.compnayPatientsForm.controls['companyId'].setValue(compnayPatients['companyId']);
        this.compnayPatientsForm.controls['patientId'].setValue(compnayPatients['patientId']);
        this.compnayPatientsForm.controls['userId'].setValue(compnayPatients['userId']['userId']);
        openAddOverlaydiv();
    }

    onClearAdd() {
        this.compnayPatientsForm.reset();
        this.compnayPatientsForm.markAsUntouched();
        this.updateCompanyPatientId = null;
        closeAddOverlaydiv();
    }

    findAllUsers() {
        let temp = [];
        this.startLoader();
        this.usersServices.findAllUsers(null, null, null).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    temp = res['data'];
                    for (let object of temp) {
                        let dropDown = {label: '', value: ''};
                        dropDown.value = object['userId'];
                        dropDown.label = object['userName'];
                        this.usersList.push(dropDown);
                    }
                } else {
                    this.usersList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    fieldReset(control) {
        return this.compnayPatientsForm.get(control).reset();
    }

    diplayeIconInField(control) {
        return this.compnayPatientsForm.get(control)?.valid;
    }

    inputFieldDanger(control) {
        return !this.compnayPatientsForm.get(control)?.valid && this.compnayPatientsForm?.get(control)?.touched;
    }

    onCloseAdd() {
        closeAddOverlaydiv();
        this.compnayPatientsForm.reset();
    }

    onCloseSearch() {
        closeSearchOverlaydiv();
        this.compnayPatientsSearch.reset();
    }

    refresh() {
        this.countCompnayPatients();
    }

    onAddOverlayDiv() {
        openAddOverlaydiv();
        this.compnayPatientsForm.reset();
    }
    // by ali
    showHideSearchDialog() {
        this.showSearchDialog = !this.showSearchDialog;
        this.showSearchBtn = this.showSearchDialog;
        this.showAddBtn = this.showSearchDialog;
    }

    showHideAddDialog() {
        if(!this.showAddDialog) {
            this.compnayPatientsForm.reset();
        }
        this.addEditTitle = this.labels.btnAdd;
        this.showAddDialog = !this.showAddDialog;
        this.showAddBtn = this.showAddDialog;
        this.showSearchBtn = this.showAddDialog;
        this.editTag = false;
        this.updateCompanyPatientId = null;
    }
}
